import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  list: [{
    linkedListData: [{
      heading: 'Sonu Sood will assist you',
      subHeading: 'our agent will visit your premises for document collection. you can also seek assistance for plan selection from them.',
      avatarNoBgContainer: true,
      avatarIcon: 'TransactionHistoryIcon',
      noHoverEffect: true
    }, {
      subHeading: 'G-83, South City-1, Sector 41',
      avatarNoBgContainer: true,
      avatarIcon: 'TransactionHistoryIcon',
      noHoverEffect: true
    }, {
      subHeading: 'mon, 11 Jan 2023 at 01:45 pm',
      avatarNoBgContainer: true,
      avatarIcon: 'TransactionHistoryIcon',
      noHoverEffect: true
    }],
    bottomCta: {
      direction: 'row',
      leftCta: {
        title: 'reschedule',
        buttonType: 'secondary'
      },
      onLeftCtaPress: {
        id: 'left-cta'
      },
      rightCta: {
        title: 'call agent',
        buttonType: 'primary'
      },
      onRightCtaPress: {
        id: 'right-cta'
      }
    }
  }]
}, getTestId('TrackOrderCardWidgetContainer'));